import { restoreCartFromCookieStorage } from "./utils/cart";

export default {
  catalog: {
    account: {},
    cart: restoreCartFromCookieStorage(),
    accountUpdateDuring: false,
    accountUpdateComplete: null,
    accountUpdateAlert: false,
    accountUpdateAlertText: "",
    adminUserContext: {},
    eloDialogState: false,
    banPlayerDialogState: false,
    verifyPlayerDialogState: false,
    rejectPlayerDialogState: false,
    notEligiblePlayerDialogState: false,
    trackerStatsDialogState: false,
    users: [],
    reportedPlayers: [],
    newestPlayers: [],
    weeklyDataForChart: [],
    sevenDaysMatchmakingDataForChart: [],
    thirtyDaysMatchmakingDataForChart: [],
    ninetyDaysMatchmakingDataForChart: [],
    monthlyDataForChart: [],
    yearlyDataForChart: [],
    matchDurationData: {},
    sevenDaysQueueDataForChart: [],
    thirtyDaysQueueDataForChart: [],
    ninetyDaysQueueDataForChart: [],
    playersQueuedPerDayData: [],
    queueEfficiencyPerDayData: [],
    queueOutcomeDistributionData: [],
    matchmakingCapacityTrendData: [],
    serversAliveCount: 0,
    mmActivitySummary: {
      matchesLive: 0,
      matchesCreatedToday: 0,
      matchesCompletedToday: 0,
      averageMatchDuration: 0,
      completionRate: 0,
      heldGroupsNow: 0,
      blockedPlayersNow: 0,
      blockedGroupsLastTick: 0,
    },
    queueAnalitycsSummary: {
      onlineUserCount: 0,
      totalPlayersInQueue: 0,
      totalLobbies: 0,
      averageQueueDuration: 0,
    },
    user: null,
    performLogout: false,
    snackbar: null,
    toggleSnackbar: false,
  },
};
